import { Component, Input, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { SaleMemberRequestModel } from '../../models/sales/sale-member-request.model';

@Component({
  selector: 'app-sale-member-request-popup',
  templateUrl: './sale-member-request-popup.component.html',
  styleUrls: ['./sale-member-request-popup.component.scss'],
})
export class SaleMemberRequestPopupComponent implements OnInit {
  @Input() data: SaleMemberRequestModel;
  @Input() isDenied: boolean;
  public form: FormGroup;
  constructor(public readonly modal: NgbActiveModal) {}

  ngOnInit(): void {
    console.log(this.isDenied);
    this.form = SaleMemberRequestModel.asFormGroup(this.data);
  }
  formSubmit(): void {
    const saleId = this.data.saleId;
    this.data = this.form.value;
    this.data.saleId = saleId;
    this.modal.close(JSON.stringify(this.data));
  }
  IsShowSend(): boolean {
    if (
      !this.isDenied &&
      (this.data.isViewDateApplicable || this.data.isSubmitDateApplicable)
    ) {
      return true;
    }
    return false;
  }
}
